import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, TouchableOpacity, Platform } from 'react-native';
import { Input, Button, IntakeFormQuestion, Line, Colors, Icon, Text, Checkbox } from '../components';
import { Picker } from '@react-native-picker/picker';
import { StringUtils } from '../utils';

class ConsultationStartIntakeForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected_category: '',
      selected_category_questions: [],
      intake_responses: {},
      pet_interact_question: 'Is your pet unresponsive or unable to interact with you?',
      pet_breathe_question: 'Is your pet having trouble breathing?',
      pet_can_interact_response: '',
      pet_breathing_response: '',
    }
  }

  render_triage_questions = () => {
    let selected_option_style = styles.selected_triage_option;
    let option_style          = styles.triage_option;

    let interact_yes = this.state.pet_can_interact_response === 'yes' ? true : false;
    let interact_no  = this.state.pet_can_interact_response === 'no'  ? true : false;

    let breathe_yes  = this.state.pet_breathing_response    === 'yes' ? true : false;
    let breathe_no   = this.state.pet_breathing_response    === 'no'  ? true : false;

    if (this.state.pet_can_interact_response === 'no' && this.state.pet_breathing_response === 'no') {
      return <View>
        <TouchableOpacity style={{ flexDirection: 'row', justifyContent: 'space-between', paddingTop: 20, paddingBottom: 20 }}
                          onPress={ () => {
                            this.setState({ pet_breathing_response: '', pet_can_interact_response: '', selected_category: '' })
                          }}>
          <Text style={{ fontSize: 16, fontWeight: '500' }}>Triage Questions</Text>
          <Icon name={'check-circle'} color={Colors.GREEN} solid={true} />
        </TouchableOpacity>
        <Line />
      </View>
    }

    return <View style={{ marginBottom: 15 }}>
      <Text style={{ marginBottom: 15, fontSize: 16, fontWeight: '500' }}>Let’s make sure this isn’t an emergency</Text>
      <View style={{ marginBottom: 15 }}>
        <Text style={{ marginBottom: 15, fontSize: 18, color: '#4c4c4c' }}>{ this.state.pet_interact_question }</Text>
        <View style={{ flexDirection: 'row' }}>

          <Checkbox checked={interact_yes} label={'Yes'} label_color='#575762' style={{ width: 100 }} onPress={ () => { this.setState({ pet_can_interact_response: 'yes' }) }} />
          <Checkbox checked={interact_no}  label={'No'}  label_color='#575762' style={{ width: 100 }} onPress={ () => { this.setState({ pet_can_interact_response: 'no' })  }} />

        </View>
      </View>
      <View>
        <Text style={{ marginBottom: 15, fontSize: 18, color: '#4c4c4c' }}>{ this.state.pet_breathe_question }</Text>
        <View style={{ flexDirection: 'row' }}>

          <Checkbox checked={breathe_yes} label={'Yes'} label_color='#575762' style={{ width: 100 }} onPress={ () => { this.setState({ pet_breathing_response: 'yes' }) }} />
          <Checkbox checked={breathe_no}  label={'No'}  label_color='#575762' style={{ width: 100 }} onPress={ () => { this.setState({ pet_breathing_response: 'no' })  }} />

        </View>
      </View>
    </View>
  }

  render_emergency_message = () => {
    let display_emergency_message = this.state.pet_can_interact_response === 'yes' || this.state.pet_breathing_response === 'yes';
    if (display_emergency_message) {
      return <View style={{ marginBottom: 15 }}>
        <Text style={{ color: '#39C0B2', fontSize: 16 }}>This sounds like an emergency. Please call your nearest animal hospital for immediate in-person help.</Text>
      </View>
    }
  }

  render_category_section = () => {
    let display_category_section = this.state.pet_can_interact_response === 'no' && this.state.pet_breathing_response === 'no';

    if (!display_category_section) {
      return null;
    }

    if (this.state.selected_category && this.state.selected_category !== 'select') {
      let category_string = StringUtils.keyToDisplayString(this.state.selected_category)
      return <View>
        <TouchableOpacity style={{ flexDirection: 'row', justifyContent: 'space-between', paddingTop: 20, paddingBottom: 20 }}
                          onPress={ () => {
                            this.setState({ selected_category: '' })
                          }}>
          <Text style={{ fontSize: 16, fontWeight: '500' }}>{ category_string }</Text>
          <Icon name={'check-circle'} color={Colors.GREEN} solid={true} />
        </TouchableOpacity>
        <Line />
      </View>
    }

    let border_color = Platform.OS === 'web' ? Colors.PRIMARY : 'white';
    let border_width = Platform.OS === 'web' ? 2 : 0;

    return <View style={{ marginBottom: 15 }}>
      <Text style={{ fontSize: 16, fontWeight: '500', marginTop: 20, marginBottom: 20 }}>Select a category</Text>
      <Picker
        style={{ borderRadius: 10, backgroundColor: 'white', padding: 10, color: 'grey', borderColor: border_color, borderWidth: border_width }}
        selectedValue={this.state.selected_category}
        onValueChange={(selected_category) => {
          let filtered_questions = this.filter_intake_category_questions(selected_category);
          this.setState({ selected_category: selected_category, selected_category_questions: filtered_questions, intake_responses: {} });
        }}>
        <Picker.Item label="Select Subject" value="select" />
        <Picker.Item label="Allergies" value="allergies" />
        <Picker.Item label="Anxiety"   value="anxiety" />
        <Picker.Item label="Behavior"  value="behavior" />
        <Picker.Item label="Dental"    value="dental" />
        <Picker.Item label="General Advice" value="general_advice" />
        <Picker.Item label="Joint Health"   value="joint_health" />
        <Picker.Item label="Nutrition"      value="nutrition" />
        <Picker.Item label="Sensitive Stomach" value="sensitive_stomach" />
        <Picker.Item label="Skin and Ears"     value="skin_and_ears" />
      </Picker>
    </View>
  }

  render_intake_questions = () => {

    if (!this.state.selected_category || this.state.selected_category === 'select') {
      return null;
    }

    let category_questions = this.state.selected_category_questions;
    let question_rows      = category_questions.map((question_obj, index) => {
      let question_index = question_obj.index;
      let question_text  = question_obj.question_text;

      return <IntakeFormQuestion
                key={index}
                question={question_obj}
                on_change={ (intake_response) => {
                  let updated_responses = Object.assign({}, this.state.intake_responses);
                  updated_responses[question_index] = intake_response;
                  this.setState({ intake_responses: updated_responses });
                }}
              />
    })

    return <View>
      <Text style={{ fontWeight: '500', marginTop: 20, marginBottom: 20, fontSize: 16 }}>Intake Questions</Text>
      { question_rows }
    </View>
  }

  render_error_message = () => {
    let error_message = this.props.error_message;

    if (error_message) {
      return <View style={{ marginBottom: 20 }}>
        <View style={{ backgroundColor: Colors.RED, padding: 15, borderRadius: 12 }}>
          <Text style={{ color: 'white', fontWeight: '500' }}>{ error_message }</Text>
        </View>
      </View>
    }
  }

  render_submit_responses = () => {
    let triage_responses    = this.generate_triage_responses();
    let intake_responses    = this.state.intake_responses ? Object.values(this.state.intake_responses) : [];
    let selected_category   = this.state.selected_category;
    let dont_proceed        = triage_responses[this.state.pet_interact_question] === 'yes' || triage_responses[this.state.pet_breathe_question] === 'yes';
    let submit_button_title = dont_proceed ? 'Exit' : 'Submit';
    let hide_button         = !dont_proceed && (!selected_category || selected_category === 'select');

    if (hide_button) {
      return null;
    }

    return <View>
      { this.render_error_message() }
      <Button title={ submit_button_title }
              onPress={ () => {
                let intake_data = {
                  intake_responses: intake_responses,
                  triage_responses: triage_responses,
                  category: selected_category,
                  proceed: !dont_proceed,
                }
                this.props.continue_action(intake_data);
              }}/>
    </View>
  }

  render() {
    return (
      <View style={styles.main_container}>
        { this.render_triage_questions()  }
        { this.render_emergency_message() }
        { this.render_category_section()  }
        { this.render_intake_questions()  }
        { this.render_submit_responses()  }
      </View>
    );
  }

  generate_triage_responses = () => {
    let tirage_responses = {}
    tirage_responses[this.state.pet_interact_question] = this.state.pet_can_interact_response;
    tirage_responses[this.state.pet_breathe_question]  = this.state.pet_breathing_response;
    return tirage_responses;
  }

  filter_intake_category_questions = (category) => {
    let all_questions      = this.props.intake_questions || [];
    let selected_category  = category;
    let filtered_questions = [];

    if (!selected_category || selected_category === 'select') {
      return filtered_questions;
    }

    all_questions.forEach((question) => {
      if (question && question.category && question.category === 'core_questions') {
        filtered_questions.push(question);
      }
    });

    all_questions.forEach((question) => {
      if (question && question.category && question.category === selected_category) {
        filtered_questions.push(question);
      }
    });

    return filtered_questions;
  }

}

const styles = StyleSheet.create({
  main_container: {
    paddingRight: 20,
    paddingLeft: 20,
    paddingBottom: 20
  },
  selected_triage_option: {
    padding: 15,
    borderWidth: 2,
    borderColor: '#1dc2ff',
    borderRadius: 10,
    flex: 1,
    alignItems: 'center'
  },
  triage_option: {
    padding: 15,
    borderWidth: 2,
    borderColor: '#e7e7e7',
    borderRadius: 10,
    flex: 1,
    alignItems: 'center'
  }
});

export default ConsultationStartIntakeForm
